import type { Offer, OfferStatus } from '@/lib/types';

// Estado de una oferta determinado automáticamente por la fecha/hora actual.
export function getOfferStatus(offer: Offer, now: Date = new Date()): OfferStatus {
  const start = new Date(offer.starts_at).getTime();
  const end = new Date(offer.ends_at).getTime();
  const t = now.getTime();
  if (t < start) return 'programada';
  if (t > end) return 'finalizada';
  return 'activa';
}

// Una oferta aplica descuento solo si está habilitada manualmente (active)
// y la fecha/hora actual está dentro del período configurado.
export function isOfferActive(offer: Offer, now: Date = new Date()): boolean {
  if (!offer.active) return false;
  return getOfferStatus(offer, now) === 'activa';
}

// Calcula el precio final con el porcentaje de oferta aplicado (redondeado a 2 decimales).
export function applyOfferPercentage(base: number, percentage: number): number {
  return Math.round(base * (100 - Number(percentage))) / 100;
}

export const OFFER_STATUS_META: Record<
  OfferStatus,
  { label: string; icon: string; badge: string }
> = {
  programada: {
    label: 'Programada',
    icon: 'ri-time-line',
    badge: 'bg-secondary-100 text-secondary-900',
  },
  activa: {
    label: 'Activa',
    icon: 'ri-flashlight-line',
    badge: 'bg-accent-100 text-accent-900',
  },
  finalizada: {
    label: 'Finalizada',
    icon: 'ri-archive-line',
    badge: 'bg-foreground-100 text-foreground-700',
  },
};